import { Sanction } from './sanction.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class ManquementConstate {
    static jsonMap = {
        id: { key: 'id' },
        code: { key: 'code', optional: true, default: '' },
        libelle: { key: 'libelle', optional: true, default: '' },
        sanctionsEncourues: { key: 'sanctionsEncourues', converter: new (ArrayClassConverterFactory.build(Sanction))(), default: () => [] }
    };

    id: number;
    code: string;
    libelle: string;
    sanctionsEncourues: Sanction[];
}
